/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../../../shared/store/ui-Slice";
import { Arr, Language, ScreenReader, Sitemap, Search, ForPassengers, ForBusiness, HeaderBg, Menu, HeaderBg2, HeaderBg3, HelpLine2, Women, Elderly, Women2, LightSvg, DarkSvg } from "../svg/AllSvg";
import { Link, useNavigate, useParams } from 'react-router-dom';
import Logo from "../../../assets/images/logo.svg"
import Logo1 from "../../../assets/images/logo1.svg"
import Logo2 from "../../../assets/images/logo2.svg"
import DarkLogo from "../../../assets/images/dark-logo.svg"
import DarkLogo1 from "../../../assets/images/dark-logo1.svg"
import DarkLogo2 from "../../../assets/images/dark-logo2.svg"
import SkipToMain from "./SkipToMain";
import { useEffect, useRef, useState } from "react";
import { languages } from "../../../shared/utils/languages";
import useSelectPrimary from "../../../shared/hooks/use-selectPrimary";
import { useTranslation } from "react-i18next";
import Select, { components } from "react-select";
import SideBar from "./SideBar";
import { dataActions } from "../../../shared/store/data-Slice";
import ProfilePopup from "./ProfilePopup";
import { url } from "../../../shared/utils/url";
import useAxios from "../../../shared/hooks/use-axios";

const DropdownIndicator = (props: any) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <Arr className="min-w-[9px] fill-[#a5a5a5] dark:fill-white" />
      </components.DropdownIndicator>
    )
  );
};

const Header = ({ bg, type }: any) => {
  const theme: any = useSelector((state: any) => state.ui.theme);
  const font: number = useSelector((state: any) => state.ui.font);
  const lang: string = useSelector((state: any) => state.ui.lang);
  const tenant: string = useSelector((state: any) => state.data.tenant);
  const user: any = useSelector((state: any) => state.auth.user);
  const profile: boolean = useSelector((state: any) => state.data.profile);
  const [select, setSelect] = useState<any>(null);
  const [menu, setMenu] = useState<any>(null);
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [langValue, setLangValue] = useState<any>(null);
  const [langFocus, setLangFocus] = useState<boolean>(false);
  const [themeFocus, setThemeFocus] = useState<boolean>(false);
  const [fontOpen, setFontOpen] = useState<any>(false);
  const [loading, setIsLoading] = useState<any>(true);
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  let styles = useSelectPrimary(theme, false);
  const { i18n, t } = useTranslation('common');
  const ref: any = useRef();
  const ref1: any = useRef();
  const [data, setData] = useState<any[]>([]);

  const getMenu = async () => {
    try {
      setIsLoading(true)
      const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.menu}${type === "passenger" ? "passenger-main-menu/" : "recruitment-main-menu/"}`);

      if (res && res?.status === 200) {
        setData(res?.data)
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false)
      console.error("error while feching header menu", error);
    }
  };

  useEffect(() => {
    if (data?.length > 0) {
      let route: any;
      let obj: any = { mainmenu: "", submenu: "" }
      if (!!params?.lang) {
        if (window.location.pathname === `/${lang}`) {
          route = window.location.pathname?.replace(`/${lang}`, "/");
        } else {
          route = window.location.pathname?.replace(`/${lang}/`, "/");
        }
      } else {
        route = window.location.pathname;
      }
      for (let i = 0; i < data?.length; i++) {
        const el = data[i];
        let mainUrl: any = el?.url;
        if (route?.includes(mainUrl)) {
          obj.mainmenu = el?.title
          if (route !== "/" && (obj.mainmenu === "Home" || obj.mainmenu === "होम")) {
            obj.mainmenu = ''
          }
        }

        for (let j = 0; j < el?.subRoutes?.length; j++) {
          const s = el?.subRoutes[j];
          let subUrl: any = s?.url;
          if (route?.includes(subUrl)) {
            obj.mainmenu = el?.title
            obj.submenu = s?.title
          }
        }
      }

      setMenu(obj)
    }
  }, [data, window.location.pathname])

  useEffect(() => {
    (!!lang && !!type) && getMenu();
  }, [lang, type])

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        setFontOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref1.current && !ref1.current.contains(event.target)) {
        dispatch(dataActions.setProfile(false));
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref1]);

  const handleFont = (f: any) => {
    if (window.innerWidth <= 1400) {
      if (f === "A") {
        document.documentElement.style.fontSize = "14px";
        dispatch(uiActions.changeFont(14));
      }

      if (f === "A-") {
        if (font !== 12) {
          const cFont: number = font - 1;
          document.documentElement.style.fontSize = `${cFont}px`;
          dispatch(uiActions.changeFont(cFont));
        }
      }

      if (f === "+A") {
        if (font !== 16) {
          const cFont: number = font + 1;
          document.documentElement.style.fontSize = `${cFont}px`;
          dispatch(uiActions.changeFont(cFont));
        }
      }
    } else {
      if (f === "A") {
        document.documentElement.style.fontSize = "16px";
        dispatch(uiActions.changeFont(16));
      }

      if (f === "A-") {
        if (font !== 14) {
          const cFont: number = font - 1;
          document.documentElement.style.fontSize = `${cFont}px`;
          dispatch(uiActions.changeFont(cFont));
        }
      }

      if (f === "+A") {
        if (font !== 18) {
          const cFont: number = font + 1;
          document.documentElement.style.fontSize = `${cFont}px`;
          dispatch(uiActions.changeFont(cFont));
        }
      }
    }
  };

  const handleThemeSwitch = (theme: any) => {
    dispatch(uiActions.changeTheme(theme));
    localStorage.setItem("theme", theme);
  };

  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [sidebarOpen]);

  useEffect(() => {
    if (!!params?.lang) {
      if (params?.lang === "hi" || params?.lang === "en" || params?.lang === "mr") {
        let obj: any = languages?.find((item: any) => item?.value === params?.lang);

        if (!!obj && Object?.keys(obj)?.length > 0) {
          setLangValue(obj)
          i18n.changeLanguage(obj?.value);
          dispatch(uiActions.changeLang(obj?.value));
        } else {
          setLangValue({ label: "English", value: "en", text: "English" })
          i18n.changeLanguage("en");
          dispatch(uiActions.changeLang("en"));
        }
      } else {
        navigate("/en")
      }
    } else {
      setLangValue({ label: "English", value: "en", text: "English" })
      i18n.changeLanguage("en");
      dispatch(uiActions.changeLang("en"));
    }
  }, [params?.lang])

  useEffect(() => {
    const footerEl: any = document.getElementById('footer');
    if (!!footerEl) footerEl.style.display = 'block'
  }, [])

  const handleChange = (e: any) => {
    if (lang !== e?.value) {
      dispatch(dataActions.setSelectLang(e));
      dispatch(dataActions.setLangOpen(true));
    }
  }

  const handleOpen = (e: any, index: any, length: any) => {
    if (e?.key === "Tab") {
      setSelect(index)
    }
  }

  const handleSubOpen = (e: any, index: any) => {
    if (e?.key === "Tab") {
      !index && setSelect(null)
    }
  }

  const handleNavigateCorporate = () => {
    const protocol = window.location.protocol;
    const www = window.location.host?.includes("www.") ? true : false;
    const host = www ? window.location.host?.replace("www.", "") : window.location.host;
    let currentHost: any = !!tenant ? host?.replace(`${tenant}.`, "") : host;
    const newUrl: any = tenant === url?.subdomain?.corporate ? `${protocol}//${currentHost}` : `${protocol}//${url?.subdomain?.corporate}.${currentHost}`;
    if (params?.lang) {
      window.location.href = `${newUrl}/${params?.lang}`;
    } else {
      window.location.href = newUrl;
    }
  }

  return (
    <>
      {/* Backdrop */}
      <span
        className={`fixed top-0 left-0 z-20 ${sidebarOpen ? "block lgs:hidden" : "hidden"
          } h-screen w-full bg-[#00000080]`}
        onClick={() => setSidebarOpen(!sidebarOpen)}
      ></span>

      <div id="header" className="px-[18px] xlsm:px-[25px] xlx:px-[45px] pt-[4px] mm:pt-[8px] lgs:pt-[22px] xlx:pt-[40px] flex items-center justify-center w-full h-full">
        <div className="w-[1200px] xlx:w-[1384px] h-full">
          <div className="flex lgs:hidden items-center pl-[4px] pb-[4px] mm:pl-[8px] mm:pb-[8px]">
            <h4 className="text-blackDark dark:text-textBlackDull text-[12px] mm:text-[14px] lgl:text-[16px] xlx:text-[18px] font-bold pr-[2px] xl:pr-[4px] leading-tight">{t("header.helpline")}: </h4>
            <div className="flex items-center gap-[4px]">
              <div className="flex items-center gap-[2px] xl:gap-[5px]">
                <span title={t("header.special_helpline")} className="flex whitespace-nowrap">
                  <Women />
                  <Elderly />
                  <Women2 />
                </span>
                <a className="text-[#E30613] text-[12px] mm:text-[13px] lgl:text-[14px] xlx:text-[16px] font-bold leading-tight" href="tel:1800220220">1800220220</a>
              </div>
              <div className="flex items-center gap-[2px] xl:gap-[3px]">
                <span title={t("header.normal_helpline")}><HelpLine2 /></span>
                <a className="text-[#E30613] text-[12px] mm:text-[13px] lgl:text-[14px] xlx:text-[16px] font-bold leading-tight" href="tel:1800220221">1800220221</a>
              </div>
            </div>
          </div>
          <div className="w-full flex items-end justify-end h-[80px] xlsm:h-[100px] sm:h-[110px] mm:h-[127px] xlx:h-[150px] relative z-[2]">
            <div className="w-[calc(100%-32px)] xlsm:w-[calc(100%-44px)] mms:w-[calc(100%-342px)] xlx:w-[calc(100%-432px)] border dark:border-[#3D7EA7] border-[#82BADE] h-full dark:bg-bgDarkDull bg-white border-r-0 rounded-[5px] xlsm:rounded-[9.5px] !rounded-br-none flex flex-col">
              <div className="mx-[15px] xl:ml-[19px] xl:mr-[23px] h-[29px] xlsm:h-[41px] xlx:h-[50px] flex items-center justify-between border-b dark:border-[#454545] border-[#D8D8D8] z-[2]">
                {/* helpline */}
                <div className="hidden lgs:flex items-center lgl:pl-[7px]">
                  <h4 className="text-blackDark dark:text-textBlackDull text-[12px] mm:text-[14px] lgl:text-[16px] xlx:text-[18px] font-bold pr-[2px] xl:pr-[4px] leading-tight">{t("header.helpline")}: </h4>
                  <div className="flex items-center gap-[4px]">
                    <div className="flex items-center gap-[2px] xl:gap-[5px]">
                      <span title={t("header.special_helpline")} className="flex whitespace-nowrap">
                        <Women />
                        <Elderly />
                        <Women2 />
                      </span>
                      <a className="text-[#E30613] text-[12px] mm:text-[13px] lgl:text-[14px] xlx:text-[16px] font-bold leading-tight hover:underline focus:underline" href="tel:1800220220">1800220220</a>
                    </div>
                    <div className="flex items-center gap-[2px] xl:gap-[3px]">
                      <span title={t("header.normal_helpline")}><HelpLine2 /></span>
                      <a className="text-[#E30613] text-[12px] mm:text-[13px] lgl:text-[14px] xlx:text-[16px] font-bold leading-tight hover:underline focus:underline" href="tel:1800220221">1800220221</a>
                    </div>
                  </div>
                </div>

                <div className="flex items-center lgs:w-auto w-full justify-end">
                  {/* language change */}
                  <div aria-label={t("aria_label.lang")} title={t("aria_label.lang")} className={`flex items-center px-[4px] mx-[1px] mm:mx-[4px] lgs:mx-[6px] ${langFocus && "shadow-[0_0_0_1px_#5b44955e] dark:shadow-[0_0_0_1px_#D8D8D8] rounded-[4px]"} hover:shadow-[0_0_0_1px_#5b44955e] dark:hover:shadow-[0_0_0_1px_#D8D8D8] hover:rounded-[4px]`}>
                    <div className="mm:w-auto mm:h-auto xlsm:w-[16px] xlsm:h-[16px] w-[14px] h-[14px]">
                      <Language />
                    </div>

                    <Select options={languages} styles={styles} className="!w-full language-select" classNamePrefix="language-select" onChange={(e: any) => handleChange(e)} value={langValue} isSearchable={false} onFocus={() => setLangFocus(true)} onBlur={() => setLangFocus(false)} aria-label={t("aria_label.lang")} components={{ DropdownIndicator }} />
                  </div>

                  <div className="border-r dark:border-[#454545] border-[#D8D8D8] h-[12px] mm:h-[15px] mx-[1px]"></div>

                  {/* skip to main content */}
                  <SkipToMain />

                  <div className="border-r dark:border-[#454545] border-[#D8D8D8] h-[12px] mm:h-[15px] mx-[1px] hidden xsm:flex"></div>

                  {/* screen reader access */}
                  <div className="h-full flex items-center justify-center">
                    <button aria-label={t("aria_label.screen_reader_access")} title={t("aria_label.screen_reader_access")} className="flex items-center justify-center hover:shadow-[0_0_0_1px_#D8D8D8] hover:rounded-[4px] focus:shadow-[0_0_0_1px_#D8D8D8] focus:rounded-[4px] py-[3px] px-[4px] mx-[1px] mm:mx-[4px] lgs:mx-[6px]" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/screen-reader-access`) : navigate(`/screen-reader-access`)}>
                      <ScreenReader />
                    </button>
                  </div>

                  <div className="xlsm:border-r dark:border-[#454545] border-[#D8D8D8] h-[12px] mm:h-[15px] mx-[1px]"></div>

                  {/* site map */}
                  <div className="h-full items-center justify-center hidden xlsm:flex">
                    <button aria-label={t("aria_label.sitemap")} title={t("aria_label.sitemap")} className="flex items-center justify-center hover:shadow-[0_0_0_1px_#D8D8D8] hover:rounded-[4px] focus:shadow-[0_0_0_1px_#D8D8D8] focus:rounded-[4px] py-[3px] px-[4px] mx-[1px] mm:mx-[4px] lgs:mx-[6px]" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/site-map`) : navigate(`/site-map`)}>
                      <Sitemap />
                    </button>
                  </div>

                  <div className="xlsm:border-r dark:border-[#454545] border-[#D8D8D8] h-[12px] mm:h-[15px] hidden xlsm:flex mx-[1px]"></div>

                  {/* font resize & theme */}
                  <div className="h-[20px] xl:h-[22px] pl-[5px] mm:pl-[8px] lgs:pl-[10px] hidden mm:flex items-center gap-[3px] z-[1] relative">
                    <button aria-label={t("aria_label.d_font")} title={t("aria_label.d_font")} className="pt-[1px] dark:bg-bgDarkDull bg-white rounded-[3px] border dark:border-[#454545] border-[#F2F2F2] flex items-center justify-center dark:text-white text-blackDark font-semibold text-[11px] mm:text-[12px] xlx:text-[13px] w-[21px] xl:w-[23px] h-full leading-tight hover:shadow-[0_0_0_1px_#D8D8D8] hover:rounded-[4px] focus:shadow-[0_0_0_1px_#D8D8D8] focus:rounded-[4px]" onClick={() => handleFont("A-")}>A-</button>
                    <button aria-label={t("aria_label.n_font")} title={t("aria_label.n_font")} className="pt-[1px] dark:bg-bgDarkDull bg-white rounded-[3px] border dark:border-[#454545] border-[#F2F2F2] flex items-center justify-center dark:text-white text-blackDark font-semibold text-[11px] mm:text-[12px] xlx:text-[13px] w-[21px] xl:w-[23px] h-full leading-tight hover:shadow-[0_0_0_1px_#D8D8D8] hover:rounded-[4px] focus:shadow-[0_0_0_1px_#D8D8D8] focus:rounded-[4px]" onClick={() => handleFont("A")}>A</button>
                    <button aria-label={t("aria_label.i_font")} title={t("aria_label.i_font")} className="pt-[1px] dark:bg-bgDarkDull bg-white rounded-[3px] border dark:border-[#454545] border-[#F2F2F2] flex items-center justify-center dark:text-white text-blackDark font-semibold text-[11px] mm:text-[12px] xlx:text-[13px] w-[21px] xl:w-[23px] h-full leading-tight hover:shadow-[0_0_0_1px_#D8D8D8] hover:rounded-[4px] focus:shadow-[0_0_0_1px_#D8D8D8] focus:rounded-[4px]" onClick={() => handleFont("+A")}>+A</button>

                    <div className={`ml-[5px] xl:ml-[8px] flex items-center h-full rounded-[3px] hover:shadow-[0_0_0_1px_#059db25e] dark:hover:shadow-[0_0_0_1px_#D8D8D8] relative ${themeFocus && "shadow-[0_0_0_1px_#059db25e] dark:shadow-[0_0_0_1px_#D8D8D8]"}`}>
                      <div className={`h-full flex items-center justify-center w-[21px] xl:w-[23px] rounded-l-[3px] leading-tight transition-all duration-75 ${theme === "dark" ? "border dark:border-[#454545] border-[#F2F2F2] border-r-0" : "dark:bg-bgPrimaryDark bg-primary"} xl:pt-[1px]`}>
                        <LightSvg className="min-w-[14.5px] w-[14.5px] min-h-[14.5px] xl:min-w-[16.5px] xlx:w-[16.5px] xl:h-[16.5px] fill-white dark:fill-white" />
                      </div>
                      <div className={`h-full flex items-center justify-center w-[21px] xl:w-[23px] rounded-r-[3px] leading-tight transition-all duration-75 ${theme === "dark" ? "dark:bg-bgPrimaryDark bg-primary" : "border dark:border-[#454545] border-[#F2F2F2] border-l-0"}`} autoFocus><DarkSvg className="min-w-[11.5px] w-[11.5px] min-h-[11.5px] xl:min-w-[13.5px] xl:w-[13.5px] xl:h-[13.5px] fill-primary dark:fill-white" />
                      </div>

                      <button aria-label={theme === "dark" ? t("aria_label.light") : t("aria_label.dark")} title={theme === "dark" ? t("aria_label.light") : t("aria_label.dark")} className={`opacity-0 absolute z-[1] w-[21px] xl:w-[23px] h-full ${theme === "light" ? "top-0 right-0 bottom-0" : "top-0 left-0 bottom-0"} xl:pt-[1px]`} onClick={() => handleThemeSwitch((theme === "light") ? "dark" : "light")} onFocus={() => setThemeFocus(true)} onBlur={() => setThemeFocus(false)}></button>
                    </div>
                  </div>

                  <div className='pl-[5px] mm:hidden relative hidden xlsm:block' ref={ref}>
                    <button aria-label={t("aria_label.utilities")} title={t("aria_label.utilities")} className="pt-[1px] dark:bg-bgDarkDull bg-white rounded-[3px] border dark:border-[#454545] border-[#F2F2F2] flex items-center justify-center dark:text-white text-blackDark font-semibold text-[11px] mm:text-[12px] xlx:text-[13px] w-[21px] xl:w-[23px] h-[20px] leading-tight hover:shadow-[0_0_0_1px_#D8D8D8] hover:rounded-[4px] focus:shadow-[0_0_0_1px_#D8D8D8] focus:rounded-[4px]" onClick={() => setFontOpen(true)}>A

                      {fontOpen && <div className='shadow-lg dark:bg-bgDark bg-[#F2F2F2] p-[4px] rounded-[3px] gap-[3px] flex flex-col absolute top-[24px]'>
                        <button aria-label={t("aria_label.d_font")} title={t("aria_label.d_font")} className="pt-[1px] dark:bg-bgDarkDull bg-white rounded-[3px] flex items-center justify-center dark:text-white text-blackDark font-semibold text-[11px] mm:text-[12px] xlx:text-[13px] w-[21px] xl:w-[23px] h-[20px] leading-tight hover:shadow-[0_0_0_1px_#D8D8D8] hover:rounded-[4px] focus:shadow-[0_0_0_1px_#D8D8D8] focus:rounded-[4px]" onClick={() => handleFont("A-")}>A-</button>
                        <button aria-label={t("aria_label.n_font")} title={t("aria_label.n_font")} className="pt-[1px] dark:bg-bgDarkDull bg-white rounded-[3px] flex items-center justify-center dark:text-white text-blackDark font-semibold text-[11px] mm:text-[12px] xlx:text-[13px] w-[21px] xl:w-[23px] h-[20px] leading-tight hover:shadow-[0_0_0_1px_#D8D8D8] hover:rounded-[4px] focus:shadow-[0_0_0_1px_#D8D8D8] focus:rounded-[4px]" onClick={() => handleFont("A")}>A</button>
                        <button aria-label={t("aria_label.i_font")} title={t("aria_label.i_font")} className="pt-[1px] dark:bg-bgDarkDull bg-white rounded-[3px] flex items-center justify-center dark:text-white text-blackDark font-semibold text-[11px] mm:text-[12px] xlx:text-[13px] w-[21px] xl:w-[23px] h-[20px] leading-tight hover:shadow-[0_0_0_1px_#D8D8D8] hover:rounded-[4px] focus:shadow-[0_0_0_1px_#D8D8D8] focus:rounded-[4px]" onClick={() => handleFont("+A")}>+A</button>
                        <div className="rounded-[3px] h-[40px] dark:bg-bgDarkDull bg-white">
                          <button aria-label={t("aria_label.light")} title={t("aria_label.light")} className="h-[20px] flex items-center justify-center w-[21px] xl:w-[23px]  bg-primary dark:bg-bgDarkDull rounded-t-[3px] leading-tight hover:shadow-[0_0_0_1px_#059db25e] hover:rounded-[4px] focus:shadow-[0_0_0_1px_#059db25e] focus:rounded-[4px] dark:hover:shadow-[0_0_0_1px_#D8D8D8] dark:focus:shadow-[0_0_0_1px_#D8D8D8]" onClick={() => handleThemeSwitch("light")}><LightSvg className="min-w-[14.5px] w-[14.5px] min-h-[14.5px] xl:min-w-[16.5px] xlx:w-[16.5px] xl:h-[16.5px] fill-white dark:fill-white" /></button>
                          <button aria-label={t("aria_label.dark")} title={t("aria_label.dark")} className="h-[20px] flex items-center justify-center w-[21px] xl:w-[23px] rounded-b-[3px] leading-tight hover:shadow-[0_0_0_1px_#D8D8D8] hover:rounded-[4px] focus:shadow-[0_0_0_1px_#D8D8D8] focus:rounded-[4px] dark:bg-bgPrimaryDark" onClick={() => handleThemeSwitch("dark")}><DarkSvg className="min-w-[11.5px] w-[11.5px] min-h-[11.5px] xl:min-w-[13.5px] xl:w-[13.5px] xl:h-[13.5px] fill-primary dark:fill-white" /></button>
                        </div>
                      </div>}
                    </button>

                  </div>
                </div>
              </div>

              <div className="ml-[15px] xl:ml-[19px] flex items-center h-[calc(100%-27px)] xlsm:h-[calc(100%-41px)] xlx:h-[calc(100%-50px)]">
                <Link to={`${!!params?.lang ? `/${params?.lang}` : "/"}`} className="hover:bg-[#f4f4f4] hover:rounded-[10px] focus:bg-[#f4f4f4] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] focus:rounded-[10px]" aria-label={t("aria_label.home")} title={t("aria_label.home")}>
                  <img src={lang === "en" ? `${theme === "dark" ? DarkLogo : Logo}` : lang === "hi" ? `${theme === "dark" ? DarkLogo1 : Logo1}` : `${theme === "dark" ? DarkLogo2 : Logo2}`} alt={`${lang === "en" ? "Mumbai Metro Rail Corporation Limited" : lang === "hi" ? "मुंबई मेट्रो रेल कॉर्पोरेशन लिमिटेड" : "मुंबई मेट्रो रेल कॉर्पोरेशन मर्यादित"}`} className='w-[220px] xs:w-[245px] xsm:w-[218px] sm:w-[275px] mms:w-[340px] lgl:w-[380px] xlx:w-auto' />
                </Link>
              </div>
            </div>

            {/* search & passengers & business */}
            <div className="absolute top-0 right-0 z-[2]">
              <div className="flex items-center ml-[-26.5px] xlsm:ml-[-34px] mms:ml-0 mms:gap-[8.5px] mms:pl-[8.5px] xlx:gap-[14px] h-[29px] xlsm:h-[40px] xlx:h-[50px] xlx:pl-[14px] pb-[4px] xlx:pr-[2px]">
                {/* search */}
                <button aria-label={t("aria_label.search")} title={t("aria_label.search")} className={`rounded-[5px] xlsm:rounded-[8px] xlx:rounded-[10px] flex items-center justify-center min-w-[24px] h-[24px] xlsm:min-w-[28px] xlsm:h-[28px] xlx:min-w-[35px] xlx:h-[35px] ${bg ? "border border-[#49A2C0] bg-[#0E606B] bg-opacity-[0.7] focus:shadow-[0_0_0_1.5px_#059db25e] hover:shadow-[0_0_0_1.5px_#059db25e]" : "bg-[#9DD6FF] bg-opacity-[0.2] border border-[#49A2C0] border-opacity-[0.2] focus:shadow-[0_0_0_1.5px_#49A2C05e] hover:shadow-[0_0_0_1.5px_#49A2C05e] dark:border-[#315F6E] dark:bg-[#1265A4] dark:bg-opacity-[0.2] dark:border-opacity-[0.2]"} dark:focus:shadow-[0_0_0_1.5px_#D8D8D8] dark:hover:shadow-[0px_0px_0px_1.5px_#D8D8D8]`} onClick={() => dispatch(dataActions.setSearchOpen(true))}><Search className={`xlx:w-auto xlx:h-auto xlsm:w-[14px] xlsm:h-[14px] w-[12px] h-[12px] ${bg ? "stroke-white" : "stroke-primary dark:stroke-white"}`} /></button>
                <div className="border-r dark:border-[#969696] border-[#B8B8B8] h-[24px] xlsm:h-[28px] xlx:h-[35px] mms:block hidden"></div>
                <button onClick={() => !!params?.lang ? navigate(`/${params?.lang}`) : navigate(`/`)} className={`leading-tight text-[12px] xlx:text-[14px] font-bold text-white whitespace-nowrap uppercase w-[140.5px] xlx:w-[170px] rounded-[8px] xlx:rounded-[10px] items-center justify-center px-[10px] h-[28px] xlx:h-[35px] gap-[2px] xlx:gap-[4px] mms:flex hidden ${bg ? "border border-[#49A2C0] bg-[#0E606B] bg-opacity-[0.7]" : "dark:bg-bgPrimaryDark bg-primary"} focus:shadow-[0_0_0_1.5px_#059db25e] hover:shadow-[0_0_0_1.5px_#059db25e] dark:focus:shadow-[0_0_0_1.5px_#D8D8D8] dark:hover:shadow-[0px_0px_0px_1.5px_#D8D8D8]`}><ForPassengers className="xlx:w-auto xlx:h-auto w-[20px] h-[21px]" /> {t("header.for_passenger")}</button>
                <button onClick={handleNavigateCorporate} className={`leading-tight text-[12px] xlx:text-[14px] whitespace-nowrap font-bold uppercase w-[137.8px] xlx:w-[170px] rounded-[8px] xlx:rounded-[10px] mms:flex hidden items-center justify-center px-[10px] h-[28px] xlx:h-[35px] gap-[6px] xlx:gap-[10px] ${bg ? "text-white border border-[#49A2C0] bg-[#0E606B] bg-opacity-[0.7]" : "dark:text-textBlackDull text-[#7f7f7f] dark:bg-bgDarkDull dark:bg-opacity-[0.1] bg-white dark:border-white dark:border-opacity-[0.1] border border-[#e7e7e7]"} focus:shadow-[0_0_0_1.5px_#D8D8D8] hover:shadow-[0px_0px_0px_1.5px_#D8D8D8]`}><ForBusiness className={`xlx:w-auto xlx:h-auto w-[15px] h-[16px] ${bg ? "fill-white" : "dark:fill-textBlackDull fill-[#7f7f7f]"}`} /> {t("header.for_business")}</button>
              </div>
            </div>

            {/* header menu */}
            <div className="absolute top-0 right-0 bottom-0 flex items-end justify-end z-[1]">
              <nav className="h-[calc(100%-29px)] xlsm:h-[calc(100%-41px)] xlx:h-[calc(100%-50px)] flex items-center gap-[15px] xl:gap-[20px] px-[15px] xl:px-[24px]">
                {loading ?
                  <ul className="hidden items-center h-full gap-[20px] xl:gap-[26px] lgs:flex animate-pulse">
                    <li className="h-[12px] bg-gray-200 rounded-full dark:bg-gray-700 w-[70px]"></li>
                    <li className="h-[12px] bg-gray-200 rounded-full dark:bg-gray-700 w-[70px]"></li>
                    <li className="h-[12px] bg-gray-200 rounded-full dark:bg-gray-700 w-[70px]"></li>
                    <li className="h-[12px] bg-gray-200 rounded-full dark:bg-gray-700 w-[70px]"></li>
                    <li className="h-[12px] bg-gray-200 rounded-full dark:bg-gray-700 w-[70px]"></li>
                  </ul>
                  : <ul className="hidden items-center h-full gap-[20px] xl:gap-[26px] lgs:flex">
                    {Array.isArray(data) && data?.map((item: any, index: number) => (
                      <li key={index} className="group h-full relative">
                        {(menu?.mainmenu === item?.title) && <div className="absolute top-0 left-0 right-0 flex items-center justify-center w-full">
                          <div className="h-[3px] duration-300 flex items-center justify-center w-[19px] dark:bg-white bg-primaryText rounded-full mt-[28px] xlx:mt-[34px]"></div>
                        </div>}
                        <Link to={!!params?.lang ? `${item?.url === "/" ? `/${params?.lang}` : `/${params?.lang + item?.url}`}` : item?.url} className={`flex items-center *:font-medium font-medium gap-[6px] h-full ${(menu?.mainmenu === item?.title) ? "dark:text-white text-primaryText" : `${select === index ? "text-primary dark:text-primary" : "text-blackDull dark:text-textBlackDull"} group-hover:text-primary dark:group-hover:text-primary`}`} onClick={(e: any) => item?.subRoutes?.length > 0 && e.preventDefault()} onKeyDown={(e: any) => handleOpen(e, index, item?.subRoutes?.length)} onFocus={() => setSelect(index)} onBlur={() => setSelect(null)}>
                          <h5>{item?.title}</h5>
                          {item?.subRoutes?.length > 0 && <Arr className={`${(menu?.mainmenu === item?.title) ? "fill-primaryText dark:fill-white" : `${select === index ? "fill-primary dark:fill-primary" : "fill-blackDark dark:fill-white"} group-hover:fill-primary dark:group-hover:fill-primary`} min-w-[9px]`} />}
                        </Link>
                      </li>
                    ))}
                  </ul>}


                <div className="border-r dark:border-[#4A4A4A] border-[#7C7C7C] h-[25px] sm:h-[28px] lgs:h-[2] order-2 lgs:order-1 hidden xlsm:block lgs:flex"></div>
                <div className="relative order-1 lgs:order-2 hidden xlsm:block mx-[-6px]" ref={ref1}>
                  <button onClick={() => !!user ? dispatch(dataActions.setProfile(true)) : dispatch(dataActions.setLoginOpen(true))} className="focus:shadow-[0_0_0_1px_#D8D8D8] hover:shadow-[0px_0px_0px_1px_#D8D8D8] hover:rounded-[4px] focus:rounded-[4px] px-[6px]">
                    {!!user ? <h5 className="flex items-center gap-[4px] lg:gap-[8px] dark:text-textBlackDull text-blackDark font-semibold"><span className="truncate w-[80px] sm:w-full">{user?.first_name + " " + user?.last_name}</span>  <Arr className="min-w-[9px] fill-[#1C1B1F] dark:fill-white" /></h5> : <h5 className="dark:text-textBlackDull text-blackDark font-semibold">{t("header.login_signup")}</h5>}
                  </button>
                  {profile && <ProfilePopup type={`${tenant === url?.subdomain?.recruitment ? "recruitment" : "passenger"}`} />}
                </div>
                <button aria-label={t("aria_label.menu")} title={t("aria_label.menu")} className="lgs:hidden order-3 xsm:mr-[10px] xsm:ml-[-6px] min-w-[30px] h-[30px] flex items-center justify-center focus:shadow-[0_0_0_1px_#059db25e] hover:shadow-[0_0_0_1px_#059db25e] hover:rounded-[4px] focus:rounded-[4px]" onClick={() => setSidebarOpen(true)}>
                  <Menu />
                </button>
              </nav>
            </div>

            {/* curve */}
            <div className="absolute right-0 top-0">
              <div className="hidden xlx:block">
                <HeaderBg />
              </div>

              <div className="xlx:hidden mms:block hidden">
                <HeaderBg2 />
              </div>

              <div className="mms:hidden block">
                <HeaderBg3 />
              </div>
            </div>

            {/* small rectangle */}
            <div className="min-w-[32px] xlsm:min-w-[44px] mms:min-w-[342px] xlx:min-w-[432px] border dark:border-[#3D7EA7] border-[#82BADE] border-l-0 border-t-0 h-[calc(100%-29px)] xlsm:h-[calc(100%-41px)] xlx:h-[calc(100%-52px)] dark:bg-bgDarkDull bg-white rounded-[5px] xlsm:rounded-[9.5px] !rounded-l-none relative">
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <SideBar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} menu={data} selectedMenu={menu} select={select} setSelect={setSelect} handleOpen={handleOpen} handleNavigateCorporate={handleNavigateCorporate} login={true} />
    </>

  );
};

export default Header;

